import FormationsPage from './FormationsPage';

export default FormationsPage;
